import React, { useState } from "react"
import { getApiUrl, gup } from "../utils/utils"
import { Helmet } from "react-helmet"
import Footer from "./Footer"
import LoaderDownload from "./LoaderDownload"
import iconLock from "../assets/img/lockGrey.png"
import "../assets/css/protectedDeposit.scss"
import { useTranslation } from "react-i18next"

export default function ProtectedDeposit(props) {
    const {
        whitemarkBackground,
        whitemarkBtnColor,
        whitemarkFavicon,
        whitemarkLogo,
        whitemarkTitle,    
        depositBoxName,
    } = props
    
    const [t] = useTranslation()
    
    const [password, setPassword] = useState()
    const [error, setError] = useState()
    const [isLoading, setIsLoading] = useState(false)

    async function validateForm() {
        await fetch(`${getApiUrl()}/api/external/depositboxes/token`, { method: "POST", headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
            "hash1": gup('hash1'),
            "hash2": gup('hash2'),
            "uh1": gup('uh1'),
            "uh2": gup('uh2'),
            "token": gup('t'),
            "password": password,
            "depositBox": gup('id')
        })})
        .then((res) => res.json())
        .then((data) => {
            if (data.code === 403) {
                setError(t('protectedDepositBox.invalidPassword'))
            } else if (data.code === 429) {
                setError(t('protectedDepositBox.blockedDepositBox'))
            } else {
                props.getProtectedDepositInfo(data.box ? data.box : data, data.errorMessage);
            }
            
            if (data.code) {
                localStorage.removeItem("password")
            } else {
                localStorage.setItem("password", password)
            }
            setIsLoading(false)
        })
        .catch((error) => {
            console.log("ERROR1 = ", error)
        })
    }

    return (
        <div className="component-protected-deposit main">
            <Helmet>
                <title>{whitemarkTitle}</title>
                {<link rel="shortcut icon" href={whitemarkFavicon} />}
                <style type="text/css">
                    {`
                        .main {
                            background:url(${whitemarkBackground});
                            background-size:cover; 
                            background-attachment: fixed;
                        }

                        .main>div.darker{
                            background-color: rgba(32,32,48,0.7);
                            min-height: 100vh;
                        }
                        
                        .logo {
                            background-image: url(${whitemarkLogo});
                        }

                        button.orangeBtn {
                            background-color: ${whitemarkBtnColor};
                        }
                    `}
                </style>
            </Helmet>
            <div className={/*whitemarkTitle === "LockSelf Deposit Box" ? "darker" :*/ "noDark"}>
                <div className="container-fluid">
                    <div className="row rowDepot">
                        <div className="col-12">
                            <div className="logo"></div>
                        </div>
                        <div className="col-xl-4 col-lg-5 col-md-6 col-sm-8 col-xs-12 mColumn-notFound">
                            <div className="wrongToken">
                                <div className="shareLabel">
                                    <h2>{t("protectedDepositBox.title")}</h2>
                                    <p className="deposit-box-name">{depositBoxName}</p>
                                </div>
                                <div className="Central">
                                    <div className="Card tokenVs">
                                        <div className="boxInfo">
                                            <img src={iconLock} alt="lock logo" className="lock-icon"/>
                                            <div className="password-container">
                                                <input type="password" placeholder={t('protectedDepositBox.password')} value={password} onChange={(v) => setPassword(v.target.value)} className={`input-password ${error && 'has-error'}`}/>
                                                {error && 
                                                    <p className="errorMessage">{error}</p>
                                                }
                                            </div>
                                            <button className="orangeBtn" type="button" onClick={() => password ? (validateForm(), setIsLoading(true)) : ""}>{t('protectedDepositBox.validate')}</button>
                                        </div>
                                        {isLoading && <LoaderDownload />}
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}